import { Div, Button } from '@codesuma/baseline'
import tasks from '../../../services/tasks'
import phoneReminders from '../../../services/phone-reminders'
import { IDayCell } from '../../../services/calendar'
import { TaskRow } from './task-row'
import { ReminderRow } from './reminder-row'
import style from './index.module.css'

// The day's to-dos, and the line that starts another one. Making one happens on
// its own page — the wizard the month's list opens too — so this is the list, the
// offer, and nothing else. It stays on an empty day now, because the offer is
// the only way in from here. On an iPhone the day's reminders from the
// Reminders app follow Emrouz's own, when settings asks for them.

// Material Design "add" icon (Apache 2.0), inherits currentColor.
const PLUS_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/></svg>'

export const Tasks = (day: IDayCell) => {
    const base = Div()
    base.addClass(style.tasks)

    // The rows alone, so the add line under them stays out of the redraw.
    const list = Div()
    base.append(list)

    // "another" once there is one to be another of, so an empty day reads as an
    // invitation rather than as a list with nothing in it.
    const add = Button()
    add.addClass(style.addRow, style.columnAdd, style.ruledAdd)
    add.on('click', () => base.emit('add-task', day))
    base.append(add)

    // Drawn again whenever a row leaves the list — put off to another day, or
    // deleted. Ticking one off does not come through here: the row marks itself
    // and stays where it is.
    const render = () => {
        list.empty()
        const rows = tasks.forDay(day)
        for (const task of rows) {
            const row = TaskRow(task)
            // Up to the page rather than redrawn here: putting a task off moves
            // it to a day whose slide is already built and sitting off-screen,
            // and only the page can redraw those.
            row.on('changed', () => base.emit('changed'))
            list.append(row)
        }
        for (const reminder of phoneReminders.forDay(day)) {
            const row = ReminderRow(reminder)
            row.on('open', () => phoneReminders.open())
            list.append(row)
        }
        const label = rows.length
            ? (day.isToday ? 'افزودن کار دیگری برای امروز' : 'افزودن کاری دیگر')
            : (day.isToday ? 'افزودن کاری برای امروز' : 'افزودن کار جدید')
        add.html(`${PLUS_SVG}<span>${label}</span>`)
    }
    render()

    return base
}
